"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditBoxReviewPreview = exports.EditBoxReviewPackage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OoxmlContent = _interopRequireDefault(require("@common/components/remedy/OoxmlContent"));
var _revisionTitle = require("@common/components/remedy/revision-title");
var _cardLiveProposal = require("../chat/proposal-card/card-live-proposal");
var _editBoxReview = require("./edit-box-review");
var _LiveProposalPanel = require("./LiveProposalPanel");
var _RevisionLegend = _interopRequireDefault(require("./RevisionLegend"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var EditBoxReviewPackage = exports.EditBoxReviewPackage = function EditBoxReviewPackage(_ref) {
  var shownPackageOoxml = _ref.shownPackageOoxml;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "overflow-x-auto",
    "data-sentry-component": "EditBoxReviewPackage",
    "data-sentry-source-file": "EditBoxReviewPreview.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RevisionLegend.default, {
      ooxml: shownPackageOoxml,
      alwaysListedAuthors: [],
      "data-sentry-element": "RevisionLegend",
      "data-sentry-source-file": "EditBoxReviewPreview.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
      ooxml: shownPackageOoxml,
      style: _LiveProposalPanel.INHERITED_TYPOGRAPHY,
      getHtmlTitleProp: _revisionTitle.revisionTitleOf,
      drawMoveMarks: true,
      drawReplacementGaps: true,
      "data-sentry-element": "OoxmlComponent",
      "data-sentry-source-file": "EditBoxReviewPreview.tsx"
    })]
  });
};
var EditBoxReviewPreview = exports.EditBoxReviewPreview = function EditBoxReviewPreview(_ref2) {
  var textRedlineProposed = _ref2.textRedlineProposed,
    author = _ref2.author,
    review = _ref2.review;
  var shownPackageOoxml = (0, _react.useMemo)(function () {
    return (0, _cardLiveProposal.shownPreviewPackageOf)((0, _editBoxReview.editBoxReviewPackageOf)(textRedlineProposed, author, review), review.stampedAt, review.draft);
  }, [textRedlineProposed, author, review]);
  if (!shownPackageOoxml) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(EditBoxReviewPackage, {
    shownPackageOoxml: shownPackageOoxml,
    "data-sentry-element": "EditBoxReviewPackage",
    "data-sentry-component": "EditBoxReviewPreview",
    "data-sentry-source-file": "EditBoxReviewPreview.tsx"
  });
};